import { makeAutoObservable, runInAction } from 'mobx';
import {
  IElectricMeter,
  IElectricMeterConsumptionParams,
  IElectricMeterParams,
} from 'src/@types/Choqorak/Settings/ElectricMeter';
import agent from 'src/api/agent';
export default class ElectricMeterStore {
  openDialog = false;

  openConsuptionDialog = false;

  ElectricMeterRegistry = new Map<number, IElectricMeter>();

  editMode = false; //When click on edit button

  ConsumptionEditMode = false; //When click on edit button

  selectedElectricMeter: IElectricMeter | undefined = undefined;

  totalRecord: number = 0;

  selectedElectricMeterDetail: IElectricMeter | undefined;

  ElectricMeterConsumptionList: IElectricMeter[] = [];

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get ElectricMeterList() {
    return Array.from(this.ElectricMeterRegistry.values());
  }

  setElectricMeterList = (ElectricMeter: IElectricMeter) => {
    this.ElectricMeterRegistry.set(ElectricMeter.electricMeterId!, ElectricMeter);
  };

  //Pagination
  loadElectricMeter = async (params: IElectricMeterParams) => {
    // this.ElectricMeterRegistry.clear();
    try {
      const result = await agent.ElectricMeter.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setElectricMeterList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ElectricMeterSearch = async (params: IElectricMeterParams) => {
    this.ElectricMeterRegistry.clear();
    this.loadElectricMeter(params);
  };

  getElectricMeterFromRegistry = (id: number) => {
    let ElectricMeter = this.ElectricMeterRegistry.get(id);

    if (ElectricMeter) {
      this.editMode = true;
      this.selectedElectricMeter = ElectricMeter;
    }
  };

  clearSelectedElectricMeter = () => {
    this.editMode = false;
    this.selectedElectricMeter = undefined;
    this.selectedElectricMeterDetail = undefined;
  };


  deleteElectricMeter = async (id: number, remark?: string) => {
    try {
      await agent.ElectricMeter.delete(id, remark!);
      runInAction(() => {
        this.ElectricMeterRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  setOpenCloseConsumptionDialog = () => (this.openConsuptionDialog = !this.openConsuptionDialog);

  createElectricMeter = async (ElectricMeter: IElectricMeter) => {
    await agent.ElectricMeter.create(ElectricMeter);
    runInAction(() => {
      this.loadElectricMeter({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedElectricMeter();
    });
  };

  updateElectricMeter = async (ElectricMeter: IElectricMeter) => {
    await agent.ElectricMeter.update(ElectricMeter);

    runInAction(() => {
      this.loadElectricMeter({ pageIndex: 0, pageSize: 5 });
      this.ElectricMeterRegistry.delete(ElectricMeter.electricMeterId!);
      this.ElectricMeterRegistry.set(ElectricMeter.electricMeterId!, ElectricMeter);
      this.clearSelectedElectricMeter();
    });
  };

  loadElectricMeterDetail = async (id: number) => {
    try {
      const getElectricMeterDetail = await agent.ElectricMeter.getDetail(id);
      runInAction(() => {
        this.selectedElectricMeterDetail = getElectricMeterDetail;
      });
    } catch (error) { }
  };

  loadElectricConsumptionPayment = async (params: IElectricMeterConsumptionParams) => {


    const result = await agent.ElectricMeter.GetConsumptionList(params);

    runInAction(() => {
      this.ElectricMeterConsumptionList = result.data;
      result.data.forEach((lst: any) => {
        this.setElectricMeterList(lst);
      });
    });
  };
}
